import React, { Component } from 'react'
import { Flex } from 'hljd'
import style from './style.module.less'
import Img from '@UI/Img'
import { getMoney } from '@hlj/hlj-utils'
import LabelText from '@components/JiaMeng/NewCustomer/detail/right/cards/LabelText'
import { ORDER_PATH_A } from '@constant'
import { observer, inject } from 'mobx-react'
import { dGet } from '@core/utils'

@inject('detailStore')
@observer
export default class extends Component {
  render() {
    const { orderDetail } = this.props.detailStore
    const { orderSub } = orderDetail
    const { id, parentOrderNo, paidMoney, statusName } = orderSub || {}
    const { title, coverPath, showPrice } = dGet(orderSub, 'setMeal', {}) || {}

    return (
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => window.open(`${ORDER_PATH_A}/detail/${id}`)}
      >
        <LabelText label="关联用户订单：" block style={{ marginBottom: 20 }}>
          {parentOrderNo}
        </LabelText>

        {/* title 不存在认为 setMeal 不显示 */}
        {title && (
          <Flex className={style.item}>
            <Img
              style={{ width: 128, height: 80, marginRight: 20, flexShrink: 0 }}
              src={coverPath}
            />
            <Flex d="v" sp>
              <Flex sp className={style.info}>
                <div className={style.title}>{title}</div>
                <div className={style.payStatus}>{statusName}</div>
              </Flex>

              <Flex sp className={style.status}>
                <div className={style.price}>{getMoney(showPrice)}</div>
                <div className={style.payValue}>已付{paidMoney}元</div>
              </Flex>
            </Flex>
          </Flex>
        )}
      </div>
    )
  }
}
